export default __webpack_public_path__ + "075515e.png";